import { useState, useRef, useEffect } from "react";
import "./report.scss";
import VisibilityOffOutlinedIcon from "@mui/icons-material/VisibilityOffOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ArrowDropDownOutlinedIcon from "@mui/icons-material/ArrowDropDownOutlined";
import { useTranslation } from "react-i18next";

function MetricCard({ label, value }) {
   const { t } = useTranslation()
  return (
    <div
      style={{
        flex: 1,
        minWidth: 160,
        background: "#fff",
        borderRadius: 10,
        padding: "14px 20px",
        boxShadow: "0 6px 20px rgba(0,0,0,0.1)",
      }}
    >
      <div style={{ fontSize: 14, color: "#94a3b8", marginBottom: 6 }}>
        {t(label)}
      </div>
      <div style={{ fontSize: 16, fontWeight: 600, color: "#1e293b" }}>
        {t(value)}
      </div>
    </div>
  );
}

export default function Header({ title, metrics }) {
  const { t } = useTranslation()
  const [showAnalytics, setShowAnalytics] = useState(true);
  const [showMoreActions, setShowMoreActions] = useState(false);
  const moreRef = useRef();

  useEffect(() => {
    const h = (e) => {
      if (moreRef.current && !moreRef.current.contains(e.target))
        setShowMoreActions(false);
    };
    document.addEventListener("mousedown", h);
    return () => document.removeEventListener("mousedown", h);
  }, []);

  return (
    <div className="header-container">
      <div className="top-bar">
        <div className="header-breadcrumb">
          <span
            className="breadcrumb-link"
            onClick={() => window.history.back()}
          >
            {t("Report")}
          </span>
          <span className="breadcrumb-separator">›</span>
          <span className="breadcrumb-title">{t(title)}</span>
        </div>

        <div ref={moreRef} className="more-actions-wrapper">
          <button
            onClick={() => setShowMoreActions((o) => !o)}
            className="more-actions-btn"
          >
            {t("More actions")} <ArrowDropDownOutlinedIcon fontSize="medium" />
          </button>
          {showMoreActions && (
            <div className="dropdown-box">
              <button
                className="dropdown-item"
                onClick={() => setShowAnalytics((o) => !o)}
              >
                {showAnalytics ? (
                  <VisibilityOffOutlinedIcon />
                ) : (
                  <VisibilityOutlinedIcon fontSize="medium" />
                )}
                {showAnalytics ? t("Hide") : t("Show")} {t("analytics")}
              </button>
            </div>
          )}
        </div>
      </div>

      {/* ── Analytics Bar ── */}
      {showAnalytics && metrics.length > 0 && (
        <div className="analytics-wrapper">
          {metrics.map((m, i) => (
            <MetricCard key={i} {...m} />
          ))}
        </div>
      )}
    </div>
  );
}
